<template>
  <div class="main_body  news_page">
    <!-- header section starts -->
    <section id="hero_section">
      <div class="container">
        <!-- navbar starts -->
        <navbar></navbar>

        <!-- navbar ends -->

        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>

        <div class="hero_content">
          <div class="row">
            <div class="col-12 text-center">
              <h1 class="h_title">music for your <br>
                online content</h1>
            </div>

          </div>
        </div>
      </div>
    </section>
    <!-- header section ends -->

    <section class="getStarted_wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center mb-5">
            <h1 class="promise_title">
              <span class="border_bottom">GM's Pledge and Guideline</span>
            </h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="promises">
              <img src="@/assets/images/computer.svg" alt="computer.svg">
              <h2>For the Creators</h2>
              <p>Delivering excellence to you, the Creators & Listeners. Crafting Lofi Hip Hop, Chill, Asian, Jazz, and beyond. Monthly music releases to enrich our ever-growing Lofi Beats collection.</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="promises">
              <img src="@/assets/images/headphones.svg" alt="headphones.svg">
              <h2>QUALITY LoFi MUSIC</h2>
              <p>We are dedicated to providing you with the finest selection of LoFi Beats right here on the GM Nanashi Website. Keep yourself in the loop by subscribing to our <a href="javascript:void(0)" data-toggle="modal" data-target="#newsletter">Newsletter</a> and stay updated on all the latest releases and news..</p>
            </div>
          </div>
        </div>

        <!-- getstarted_content starts -->
        <div class="getStarted_content">
          <div class="row justify-content-center">
            <div class="col-lg-5 col-md-6">
              <section class="youtube_section">
                <!-- latest music list -->
                <latest-music :showHeading="true"></latest-music>

              </section>
            </div>

            <div class="col-lg-5 col-md-6">
              <div class="getStarted_text">
                <h1 class="started_text">
                  READY FOR SOME CHILL LoFI BEATS?
                </h1>

                <p>GM Nanashi LoFi - Study Beats, Chill Beats and Content Beats!</p>

                <p>Did you know you can savor a taste of GMNanashi LoFi Beats right here on our website? It's easy! Explore our latest beats on the music tab, and don't forget about the Music Player at the bottom of the page.</p>

              </div>
            </div>

          </div>

        </div>
        <!-- getstarted_content ends -->

      </div>
    </section>

    <!-- frequently asked questions  -->
    <section class="question_section">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h1 class="faq_title">
              Frequently <br>
              Asked Questions
            </h1>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="faq_question">
              <h1>Do I have to credit GM Nanashi to use music?</h1>
              <p>Absolutely! Crediting our music in your content or streams is a tremendous support. It opens doors to larger audiences and expands our reach for targeted LoFi Releases. Your feedback is invaluable as it guides us in delivering the finest beats for your listening enjoyment. So, kindly give us a shout-out, mention us in comments, or include us in the "more info" section. Your recognition means the world to us!</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="faq_question">
              <h1>Which tracks are available to use?</h1>
              <p>Feel free to utilize any of the songs available on our website. There are no restrictions on the tracks. You can incorporate our music in your YouTube videos, Twitch streams, or any other content you create.</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="faq_question">
              <h1>How do I credit the music on YouTube,Twitch & Others.</h1>
              <p>To ensure proper credit, consider giving us a shout-out in your playlist or including credit in the "about us," "show more," or description sections.</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="faq_question">
              <h1>Where do I find the music?</h1>
              <p>Our music is accessible on various platforms. Finding our music is easy - simply <router-link to="/hyperlink" class="custom-anchor">here</router-link> to access external URL links leading to your favorite streaming services. Also, don't forget to check out the music player located below for a seamless listening experience.</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="faq_question">
              <h1>Can I remix, edit or use my vocals?</h1>
              <p>Sending a ticket requesting permission is strictly prohibited. Unauthorized alteration of our music will result in appropriate actions being taken.</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="faq_question">
              <h1>Can I monetize my videos or stream with your music?</h1>
              <p>You can monetize your videos and streams by adhering to our crediting rules. If you intend to use our music for advertising or selling a product, please reach out to us beforehand to ensure clarity and avoid any potential issues.</p>
            </div>
          </div>

        </div>

      </div>
    </section>

    <!-- frequently asked questions  -->

    <!-- send question section starts -->
    <section class="news_bottom_bg">
      <div class="container">
        <div class="send_question_wrapper">
          <div class="row">
            <div class="col-lg-8">
              <h1>I have another <br>
                question</h1>
            </div>
            <div class="col-lg-4 my-auto text-lg-right text-center">
              <router-link to="/contact" class="btn btn_primary btn_send_question">Send Question</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- <instagram-feed></instagram-feed> -->
      <footer></footer>
    </section>

  </div>
</template>

<script>
import Footer from '../components/Footer.vue'
import LatestMusic from '../components/LatestMusic.vue'
// import InstagramFeed from '../components/InstagramFeed.vue'
import Navbar from '../components/Navbar.vue'
export default {
  components: { Navbar, Footer, LatestMusic },
  name: 'Information',
  data () {
    return {}
  },
  methods: {}
}

</script>

<style scoped>
.custom-anchor {
  color: white;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/Information.vue